import { __read, __spreadArray } from "tslib";
import _ from 'lodash';
import { ADDRESSES_APP_DEFINITION_ID, APP_DEFINITION_ID, MY_WALLET_APP_DEFINITION_ID } from '../constants';
import { getResizedImageUrl } from '../common/resized-image-url';
import { PublicDataScopes } from './public-data-scopes';
var SdkAdapter = /** @class */ (function () {
    function SdkAdapter(Wix) {
        this.Wix = Wix;
        this.PublicDataScopes = PublicDataScopes;
        if (!this.isDashboardMode()) {
            this.PixelType = this.Wix.Analytics.PixelType;
        }
    }
    SdkAdapter.prototype.getStyleParams = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var ret = _this.Wix.Styles.getStyleParams(function (params) {
                resolve(params);
            });
            //when no style is defined then getStyleParams returns undefined and doe snot call the callBack
            if (typeof ret === 'undefined') {
                resolve({
                    numbers: {},
                    booleans: {},
                    colors: {},
                    fonts: {},
                    googleFontsCssUrl: '',
                });
            }
        });
    };
    SdkAdapter.prototype.getSiteInfo = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.getSiteInfo(resolve);
        });
    };
    SdkAdapter.prototype.getWixInstance = function () {
        return this.Wix;
    };
    SdkAdapter.prototype.getBoundingRectAndOffsets = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.getBoundingRectAndOffsets(resolve);
        });
    };
    SdkAdapter.prototype.getCurrentPageId = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.getCurrentPageId(function (pageId) { return resolve(pageId); });
        });
    };
    SdkAdapter.prototype.getViewMode = function () {
        return this.Wix.Utils.getViewMode();
    };
    SdkAdapter.prototype.isLiveSiteMode = function () {
        return this.getViewMode() === 'site';
    };
    SdkAdapter.prototype.isPreviewMode = function () {
        return this.getViewMode() === 'preview';
    };
    SdkAdapter.prototype.isFullWidth = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.Settings.isFullWidth(resolve);
        });
    };
    SdkAdapter.prototype.getAppAPI = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.Wix.Settings.getAppAPI(resolve, reject);
        });
    };
    SdkAdapter.prototype.isStandaloneMode = function () {
        return this.getViewMode() === 'standalone';
    };
    SdkAdapter.prototype.isDashboardMode = function () {
        return this.getViewMode() === 'dashboard';
    };
    SdkAdapter.prototype.isEditorMode = function () {
        return this.getViewMode() === 'editor';
    };
    SdkAdapter.prototype.getImageUrl = function (imageUrl) {
        return this.Wix.Utils.Media.getImageUrl(imageUrl);
    };
    SdkAdapter.prototype.isMobile = function () {
        return this.Wix.Utils.getDeviceType() === 'mobile';
    };
    SdkAdapter.prototype.getDeviceType = function () {
        return this.Wix.Utils.getDeviceType();
    };
    SdkAdapter.prototype.isVisualFocusEnabled = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.isVisualFocusEnabled(resolve);
        });
    };
    SdkAdapter.prototype.getResizedImageUrl = function (mediaItem, requiredDimensions) {
        return getResizedImageUrl(this.Wix.Utils.Media, mediaItem, requiredDimensions);
    };
    SdkAdapter.prototype.getBiToken = function () {
        try {
            return this.Wix.Utils.getInstanceValue('biToken');
        }
        catch (e) {
            return '';
        }
    };
    SdkAdapter.prototype.getIsSiteOwner = function () {
        return this.Wix.Utils.getUid() === this.Wix.Utils.getSiteOwnerId();
    };
    SdkAdapter.prototype.getSiteOwnerId = function () {
        return this.Wix.Utils.getSiteOwnerId();
    };
    SdkAdapter.prototype.getMetaSiteId = function () {
        return this.Wix.Utils.getInstanceValue('metaSiteId');
    };
    SdkAdapter.prototype.getVisitorId = function () {
        return this.Wix.Utils.getInstanceValue('aid');
    };
    SdkAdapter.prototype.getUserIdentifierFoBI = function () {
        try {
            if (this.Wix.Utils.getInstanceValue('uid')) {
                return { uuid: this.Wix.Utils.getInstanceValue('uid') };
            }
            else {
                return { visitor_id: this.Wix.Utils.getInstanceValue('aid') };
            }
        }
        catch (e) {
            return { visitor_id: '' };
        }
    };
    SdkAdapter.prototype.getInstanceId = function () {
        try {
            return this.Wix.Utils.getInstanceId();
        }
        catch (e) {
            return '';
        }
    };
    SdkAdapter.prototype.getCurrentMember = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.currentMember(resolve);
        });
    };
    SdkAdapter.prototype.scrollTo = function (x, y, options) {
        this.Wix.scrollTo(x, y, options);
    };
    SdkAdapter.prototype.subscribe = function (eventName, callback, receivePastEvents) {
        if (receivePastEvents === void 0) { receivePastEvents = false; }
        return this.Wix.PubSub.subscribe(eventName, callback, receivePastEvents);
    };
    SdkAdapter.prototype.publish = function (eventName, data, isPersistent) {
        if (isPersistent === void 0) { isPersistent = false; }
        this.Wix.PubSub.publish(eventName, data, isPersistent);
    };
    SdkAdapter.prototype.unsubscribe = function (eventName, subscriptionId) {
        this.Wix.PubSub.unsubscribe(eventName, subscriptionId);
    };
    SdkAdapter.prototype.getPublicData = function (keys, scope) {
        var _this = this;
        if (this.isStandaloneMode()) {
            return new Promise(function (resolve) { return resolve({}); });
        }
        keys = _.castArray(keys);
        var promises = keys.map(function (key) { return new Promise(function (resolve) { return _this.Wix.Data.Public.get(key, { scope: scope }, resolve, function (_error) { return resolve(undefined); }); }); });
        return Promise.all(promises).then(function (promisesArr) {
            var obj = {};
            promisesArr.forEach(function (promiseResult) {
                if (promiseResult) {
                    Object.keys(promiseResult).forEach(function (key) { return (obj[key] = promiseResult[key]); });
                }
            });
            return obj;
        });
    };
    SdkAdapter.prototype.setHeight = function (height) {
        this.Wix.setHeight(height);
    };
    SdkAdapter.prototype.getCurrentConsentPolicy = function () {
        return this.Wix.Utils.getCurrentConsentPolicy();
    };
    SdkAdapter.prototype.getConsentPolicyHeader = function () {
        return this.Wix.Utils._getConsentPolicyHeader();
    };
    SdkAdapter.prototype.resizeWindow = function (width, height, callback) {
        this.Wix.resizeWindow(width, height, callback);
    };
    SdkAdapter.prototype.getWindowHeight = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var id = _this.Wix.addEventListener(_this.Wix.Events.SCROLL, function (data) {
                resolve(data.documentHeight);
                _this.Wix.removeEventListener(_this.Wix.Events.SCROLL, id);
            });
            _this.Wix.scrollBy(0, 1);
            _this.Wix.scrollBy(0, -1);
        });
    };
    SdkAdapter.prototype.wasSiteNeverSaved = function () {
        return new Promise(this.Wix.getSiteInfo).then(function (info) { return !info.baseUrl; });
    };
    SdkAdapter.prototype.saveSite = function () {
        //getDashboardAppUrl has a side effect of saving the site
        this.Wix.Settings.getDashboardAppUrl(function () {
            //
        });
    };
    SdkAdapter.prototype.openDashboard = function (options) {
        var _this = this;
        return new Promise(function (resolve) {
            options.onClose = resolve;
            _this.Wix.Settings.openDashboard(options);
        });
    };
    SdkAdapter.prototype.openModal = function (url, width, height, bareTheme) {
        var _this = this;
        if (bareTheme === void 0) { bareTheme = false; }
        var theme = bareTheme ? this.Wix.Theme.BARE : this.Wix.Theme.DEFAULT;
        return new Promise(function (resolve) {
            return _this.Wix.openModal(url, width, height, function (data) {
                resolve(data === null || data === void 0 ? void 0 : data.message);
            }, theme);
        });
    };
    SdkAdapter.prototype.openPopup = function (url, width, height, position, bareTheme) {
        var _this = this;
        if (bareTheme === void 0) { bareTheme = false; }
        var theme = bareTheme ? this.Wix.Theme.BARE : this.Wix.Theme.DEFAULT;
        return new Promise(function (resolve) {
            return _this.Wix.openPopup(url, width, height, position, function (data) {
                resolve(data === null || data === void 0 ? void 0 : data.message);
            }, theme);
        });
    };
    SdkAdapter.prototype.closeWindow = function (data) {
        if (data) {
            this.Wix.closeWindow(data);
        }
        else {
            this.Wix.closeWindow();
        }
    };
    SdkAdapter.prototype.revalidateSession = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.Wix.revalidateSession(function (success) {
                resolve(success.instance);
            }, function (error) {
                reject(error);
            });
        });
    };
    SdkAdapter.prototype.isHtml5Editor = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isLiveSiteMode() || _this.isPreviewMode() || _this.isStandaloneMode()) {
                resolve(false);
            }
            else {
                _this.Wix.Features.isSupported(_this.Wix.Features.Types.PREVIEW_TO_SETTINGS, function (isSantaEditor) {
                    resolve(!isSantaEditor);
                });
            }
        });
    };
    SdkAdapter.prototype.getSectionUrl = function (sectionId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.Wix.Utils.getSectionUrl({ sectionId: sectionId }, function (response) {
                var _a, _b;
                if (response === null || response === void 0 ? void 0 : response.url) {
                    resolve(response.url);
                }
                else {
                    console.warn("".concat(sectionId, " is missing in this site - ").concat((_a = response.error) === null || _a === void 0 ? void 0 : _a.message));
                    reject((_b = response.error) === null || _b === void 0 ? void 0 : _b.message);
                }
            });
        });
    };
    SdkAdapter.prototype.buildCustomizedUrl = function (identifier, itemData, options) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            _this.Wix.Location.buildCustomizedUrl(identifier, itemData, options, resolve);
        });
    };
    SdkAdapter.prototype.getCurrentSectionUrl = function () {
        return this.Wix.Utils.getSectionUrl();
    };
    /**
     * Navigate to specific page in multi section app
     *  @param sectionId - App page id defined in dev.wix.com
     *  @param state - new apps state to push into the editor history stack
     *  @param errorCB - this will be called if the hosting site does not include the section app, or if the caller's application does not include a section
     *  @param fallbackSectionId - if the navigation failed and fallbackSectionId is supplied then we try to navigate again with the fallback section Id
     */
    SdkAdapter.prototype.navigateToSection = function (sectionId, options, errorCB, fallbackSectionId) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var state = options.state, queryParams = options.queryParams, customizeTarget = options.customizeTarget;
        var allValuesDefined = !_.values(queryParams).some(_.isUndefined);
        if (!allValuesDefined) {
            throw new Error('Wix.navigateToSection must be called with defined queryParams'); //real SDK swallows this error
        }
        if (typeof errorCB === 'undefined' || errorCB === null) {
            errorCB = function (event) {
                var message = event.error.message;
                //try to navigate with fallbackSectionId
                if (fallbackSectionId && message.indexOf(sectionId) !== -1) {
                    _this.Wix.Utils.navigateToSection({ sectionId: fallbackSectionId, state: state, queryParams: queryParams }, function () {
                        throw new Error("Unable to navigate exception ".concat(fallbackSectionId, " ").concat(state, " with error ").concat(message));
                    });
                }
                throw new Error("Unable to navigate exception ".concat(sectionId, " ").concat(state, " with error ").concat(message));
            };
        }
        this.Wix.Utils.navigateToSection({ sectionId: sectionId, state: state, queryParams: queryParams, customizeTarget: customizeTarget }, errorCB);
    };
    SdkAdapter.prototype.navigateTo = function (link, errorCB) {
        this.Wix.navigateTo(link, errorCB);
    };
    SdkAdapter.prototype.getSiteMap = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.Wix.getSiteMap(resolve);
        });
    };
    SdkAdapter.prototype.reportApplicationLoaded = function () {
        this.Wix.Performance.applicationLoaded();
    };
    SdkAdapter.prototype.registerCampaignPixel = function (pixelType, pixelId) {
        this.Wix.Analytics.registerCampaignPixel(pixelType, pixelId);
    };
    SdkAdapter.prototype.reportCampaignEvent = function (eventName, data) {
        if (data === void 0) { data = {}; }
        this.Wix.Analytics.reportCampaignEvent(eventName, data);
    };
    SdkAdapter.prototype.trackEvent = function (eventName, params) {
        if (this.isLiveSiteMode()) {
            this.Wix.Analytics.trackEvent(eventName, params);
        }
    };
    SdkAdapter.prototype.onInstanceChange = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.INSTANCE_CHANGED, cb);
    };
    SdkAdapter.prototype.onStyleParamsChange = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.STYLE_PARAMS_CHANGE, cb);
    };
    SdkAdapter.prototype.onSettingsUpdated = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.SETTINGS_UPDATED, cb);
    };
    SdkAdapter.prototype.onEditModeChange = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.EDIT_MODE_CHANGE, cb);
    };
    SdkAdapter.prototype.onPublicDataChange = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.PUBLIC_DATA_CHANGED, cb);
    };
    SdkAdapter.prototype.onPageNavigationIn = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.PAGE_NAVIGATION_IN, cb);
    };
    SdkAdapter.prototype.onPageNavigationOut = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.PAGE_NAVIGATION_OUT, cb);
    };
    SdkAdapter.prototype.onScroll = function (cb) {
        this.Wix.addEventListener(this.Wix.Events.SCROLL, cb);
    };
    SdkAdapter.prototype.isAppSectionInstalled = function (appDefinitionId, sectionId) {
        var _this = this;
        if (this.isStandaloneMode()) {
            return Promise.resolve(false);
        }
        var options = { appDefinitionId: appDefinitionId };
        return new Promise(function (resolve) { return _this.Wix.isAppSectionInstalled(sectionId, options, resolve); });
    };
    SdkAdapter.prototype.isAddressesAppInstalled = function () {
        return this.isAppSectionInstalled(ADDRESSES_APP_DEFINITION_ID, 'my_addresses');
    };
    SdkAdapter.prototype.isMyWalletAppInstalled = function () {
        return this.isAppSectionInstalled(MY_WALLET_APP_DEFINITION_ID, 'my_wallet');
    };
    SdkAdapter.prototype.isEcomSectionInstalled = function (sectionId) {
        return this.isAppSectionInstalled(APP_DEFINITION_ID, sectionId);
    };
    SdkAdapter.prototype.getBoolean = function (key) {
        return this.getBooleans([key]).then(function (obj) { return obj[key]; });
    };
    SdkAdapter.prototype.getBooleans = function (keys) {
        return this.getStyleParams().then(function (styleParams) {
            var booleans = styleParams.booleans;
            return keys.reduce(function (result, currentKey) {
                // eslint-disable-next-line no-prototype-builtins
                result[currentKey] = booleans.hasOwnProperty(currentKey) ? booleans[currentKey] : null;
                return result;
            }, {});
        });
    };
    SdkAdapter.prototype.openMemberLoginModal = function (locale) {
        var _this = this;
        return new Promise(function (resolve, reject) { return _this.Wix.requestLogin({ mode: 'login', language: locale }, resolve, reject); });
    };
    SdkAdapter.prototype.logoutMember = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.Wix).logOutCurrentMember.apply(_a, __spreadArray([], __read(args), false));
    };
    return SdkAdapter;
}());
export { SdkAdapter };
export default SdkAdapter;
//# sourceMappingURL=sdk-adapter.js.map